import React from 'react';
import { Factory, ShoppingCart, Briefcase, HardHat, HeartHandshake, Network } from 'lucide-react';
import { sectors } from '../data/mock';

const iconMap = {
  Factory,
  ShoppingCart,
  Briefcase,
  HardHat,
  HeartHandshake,
  Network
};

const SectorsSection = () => {
  return (
    <section className="section-spacing bg-white">
      <div className="container-main">
        {/* Section Header */}
        <div className="text-center mb-10">
          <span className="caption mb-3 block">Experiência</span>
          <h2 className="heading-1 mb-4">Setores que atendemos</h2>
          <p className="body-medium max-w-lg mx-auto">
            Atendemos empresas de diversos portes e segmentos, 
            sempre com soluções adequadas a cada realidade.
          </p>
        </div>

        {/* Sectors Grid */}
        <div className="flex flex-wrap justify-center gap-3">
          {sectors.map((sector) => {
            const IconComponent = iconMap[sector.icon];
            return (
              <div 
                key={sector.id} 
                className="flex items-center gap-2 bg-[#F7FAFC] border border-[#E2E8F0] rounded-md px-4 py-2.5 hover:border-[#D1D5DB] transition-colors"
              >
                {IconComponent && <IconComponent size={16} className="text-[#3E6B2A]" />}
                <span className="text-[#475569] text-sm font-medium">{sector.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;
